import type { PlayablePrayer, Track } from "../../src";

const hexes = {
  3: "#005552",
  6: "#9554A5",
  9: "#3C046C",
  12: "#39408E",
  15: "#380268",
  18: "#730E54",
  21: "#1E438E",
  24: "#245CAB",
  27: "#0F4278",
  30: "#101971",
};

export const mockPlayablePrayers: PlayablePrayer[] = Array.from(
  new Array(10).keys(),
).map((pIdx) => ({
  id: 10 - pIdx,
  collection_id: (pIdx + 1) * 3,
  detailed_desc:
    "This is a much longer description going into some detail about what this prayer is for. It also has a URL for some reason: https://hallow.com and also a deeplink: hallow://challenges/1",
  is_available: true,
  is_download_enabled: false,
  is_song: pIdx % 3 === 0,
  label_desc: "A short description",
  lengths: "5 min",
  shareable_quote: `"Quoting from prayer ${10 - pIdx} makes one wise."`,
  shareable_url: `https://hallow.com/prayers/${10 - pIdx}`,
  supertitle: "CHALLENGES",
  title: `Prayer ${10 - pIdx}`,
  order: null,
  prompt: `What is the ${pIdx + 1}th thing that resonated with you today?`,
  has_access: true,
  is_completed: true,
  is_favorite: false,
  is_redeemed: false,
  images: {
    large: `https://images.hallow.app/covers/${(pIdx + 1) * 3}_l.webp`,
    medium: `https://images.hallow.app/covers/${(pIdx + 1) * 3}_m.webp`,
    small: `https://images.hallow.app/covers/${(pIdx + 1) * 3}_s.webp`,
    fallback: `https://images.hallow.app/covers/${(pIdx + 1) * 3}_l.png`,
    color_hex: hexes[(pIdx + 1) * 3],
  },
  tracks: Array.from(new Array(8).keys()).map(
    (tIdx): Track => ({
      duration: 300,
      guide_id: (tIdx % 2) + 1,
      id: pIdx * 8 + tIdx + 1,
      length: "5 min",
      paid: false,
      prayer_id: pIdx + 1,
      has_transcript: false,
      media_type: "audio",
    }),
  ),
  selected_track_id: pIdx * 8 + 1,
}));
